import React, { useState } from 'react'
import PhotoLightbox from '../shared/PhotoLightbox.jsx'

function ItemConfirmModal({ item, onConfirm, onCancel }) {
  const [lightboxIndex, setLightboxIndex] = useState(null)
  const hasShelf = !!item.current_shelf_id
  const actionLabel = hasShelf ? 'Yes, Move →' : 'Yes, Put away →'
  // Display the bay only — warehouse team asked to hide the L/R/slot
  // position. current_position is still carried in state and on POSTs.
  const currentLocation = hasShelf ? item.current_shelf_id : null
  const images = Array.isArray(item.images) ? item.images : []

  return (
    <>
      <div className="modal-overlay" onClick={onCancel}>
        <div
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: 640, width: '100%' }}
        >
          <div className="modal-header">
            <h3 style={{ margin: 0, fontSize: 18 }}>{item.title}</h3>
            <button className="modal-close" onClick={onCancel} aria-label="Close">×</button>
          </div>

          <div className="modal-body-scroll">
            {/* Photo grid: 2-col on phone, 3-col >=768px */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 8,
                marginBottom: 16
              }}
              className="photo-grid"
            >
              {images.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt={`Photo ${i + 1}`}
                  onClick={() => setLightboxIndex(i)}
                  style={{
                    width: '100%',
                    aspectRatio: '1 / 1',
                    objectFit: 'cover',
                    borderRadius: 8,
                    cursor: 'zoom-in'
                  }}
                />
              ))}
            </div>

            <div className="text-sm text-muted" style={{ marginBottom: 8 }}>
              item <strong>{item.item_id || '—'}</strong>
              {' '}•{' '}
              shopify <strong>{item.shopify_product_id}</strong>
            </div>

            {currentLocation ? (
              <div style={{ fontSize: 16, marginBottom: 16 }}>
                Current shelf: <strong>{currentLocation}</strong>
              </div>
            ) : (
              <div style={{ fontSize: 16, marginBottom: 16, color: '#6b7280' }}>
                No shelf assigned yet.
              </div>
            )}

            <div
              style={{
                background: '#fef3c7',
                padding: 12,
                borderRadius: 8,
                fontSize: 16,
                marginBottom: 8
              }}
            >
              Are you confident you have the right item in your hand based on title and photos?
            </div>
          </div>

          <div
            className="modal-footer"
            style={{
              display: 'flex',
              gap: 12,
              padding: '12px 16px calc(12px + env(safe-area-inset-bottom)) 16px'
            }}
          >
            <button
              className="btn btn-secondary"
              onClick={onCancel}
              style={{ minHeight: 48, flex: 1 }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={onConfirm}
              style={{ minHeight: 48, flex: 2 }}
            >
              {actionLabel}
            </button>
          </div>
        </div>
      </div>

      {lightboxIndex != null && (
        <PhotoLightbox
          images={images}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}

      <style>{`
        @media (min-width: 768px) {
          .photo-grid { grid-template-columns: repeat(3, 1fr) !important; }
        }
      `}</style>
    </>
  )
}

export default ItemConfirmModal
